import type { PpdfSouhlasySouhlasDto } from '@gov-nx/api';
import { PpdfSouhlasyTypOsobyEnum } from './context.types';

export interface ConsentFormPrefill {
	personType?: PpdfSouhlasyTypOsobyEnum;
	poDataBoxId?: string;
	fromOvmId?: string;
	fromAgendaId?: string;
	toAgendaId?: string[];
	sharedAgendaMultiselect?: string[];
}

export const mapConsentDtoToForm = (
	dto: PpdfSouhlasySouhlasDto
): ConsentFormPrefill => {
	const prefill: ConsentFormPrefill = {};

	if (dto.kodSpravceUdaju) {
		prefill.personType = dto.osoba?.pravnickaOsoba
			? PpdfSouhlasyTypOsobyEnum.PO
			: PpdfSouhlasyTypOsobyEnum.FO;
		prefill.fromOvmId = dto.kodSpravceUdaju;
	}

	if (dto.osoba?.pravnickaOsoba?.datovaSchrankaId) {
		prefill.poDataBoxId = dto.osoba.pravnickaOsoba.datovaSchrankaId;
	}

	if (dto.kodAgendySpravceUdaju) {
		prefill.fromAgendaId = dto.kodAgendySpravceUdaju;
	}

	if (dto.kodyAgendPrijemceUdaju) {
		prefill.toAgendaId = dto.kodyAgendPrijemceUdaju;
	}

	if (dto.kodyUdaju?.length) {
		prefill.sharedAgendaMultiselect = dto.kodyUdaju;
	}

	return prefill;
};
